import { WeaTools } from 'ecCom'

export const getBlessingForm = (params = {}) => {
    return WeaTools.callApi('/api/hrm/birthday/getBlessingForm', 'GET', params);
}

export const saveBlessingForm = (params = {}) => {
    return WeaTools.callApi('/api/hrm/birthday/saveBlessingForm', 'POST', params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/sendBless.js